<template>
  <div class="referred">
    <v-row class="report-date-picker">
      <div class="col-5">
        <label class="from">از تاریخ</label>
        <date-picker v-model="start_date"></date-picker>
      </div>
      <div class="col-5">
        <label class="to">تا تاریخ</label>
        <date-picker v-model="end_date"></date-picker>
      </div>
      <div class="col-2">
        <label class="to"><br></label>

        <v-btn @click="getReports" color="primary">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-card-text>
      <div style="margin-top: 50px">
        <div class="req-list">
          <v-card
            class="mx-auto"
            style="margin: 5px;"
          >

            <v-card-title>
              فروش شعب
            </v-card-title>

            <!--            <v-card-subtitle>-->
            <!--             فروش کل-->
            <!--            </v-card-subtitle>-->

            <v-card-actions>
              <v-btn
                color="green lighten-2"
                text
              >
                {{get_currency(calculate_items(branch_sales,"TotalAmount"))}}
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="show_sale_branches = !show_sale_branches"
              >
                <v-icon>{{ show_sale_branches ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show_sale_branches">
                <v-divider></v-divider>

                <v-card-text>
                  <div v-for="s in branch_sales">
                    <span>{{ s.Title }}</span>
                    <span style="float: left">{{ get_currency(s.TotalAmount) }}</span>
                    <hr>
                  </div>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
          <!--          ************************************************-->
          <v-card
            class="mx-auto"
            style="margin: 5px;"
          >

            <v-card-title>
              خرید شعب
            </v-card-title>
            <v-card-actions>
              <v-btn
                color="green lighten-2"
                text
              >
                {{get_currency(calculate_items(branch_buys,"TotalAmount"))}}
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="show_buy_branches = !show_buy_branches"
              >
                <v-icon>{{ show_buy_branches ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show_buy_branches">
                <v-divider></v-divider>

                <v-card-text>
                  <div v-for="s in branch_buys">
                    <span>{{ s.Title }}</span>
                    <span style="float: left">{{ get_currency(s.TotalAmount) }}</span>
                    <hr>
                  </div>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
          <!--          ************************************************-->
          <v-card
            class="mx-auto"
            style="margin: 5px;"
          >

            <v-card-title>
              هزینه شعب
            </v-card-title>
            <v-card-actions>
              <v-btn
                color="green lighten-2"
                text
              >
                {{get_currency(calculate_items(branch_cost,"TotalAmount"))}}
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="show_cost_branches = !show_cost_branches"
              >
                <v-icon>{{ show_cost_branches ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show_cost_branches">
                <v-divider></v-divider>

                <v-card-text>
                  <div v-for="s in branch_cost">
                    <span>{{ s.Title }}</span>
                    <span style="float: left">{{ get_currency(s.TotalAmount) }}</span>
                    <hr>
                  </div>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
          <!--          ************************************************-->
          <v-card
            class="mx-auto m-1"
            style="margin: 5px;"

          >

            <v-card-title>
              آمار دستگاه پوز ها
            </v-card-title>

            <!--            <v-card-subtitle>-->
            <!--             فروش کل-->
            <!--            </v-card-subtitle>-->

            <v-card-actions>
              <v-btn
                color="green lighten-2"
                text
              >
                {{get_currency(calculate_items(terminal_sales,"TotalAmount"))}}
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="show_sale_terminal = !show_sale_terminal"
              >
                <v-icon>{{ show_sale_terminal ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show_sale_terminal">
                <v-divider></v-divider>

                <v-card-text>
                  <div v-for="s in terminal_sales">
                    <span>{{ s.Title }}</span>
                    <span style="float: left">{{ get_currency(s.TotalAmount) }}</span>
                    <hr>
                  </div>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
          <!--          ************************************************-->
          <v-card
            class="mx-auto m-1"
            style="margin: 5px;"

          >

            <v-card-title>
              گزارش حساب بانکی
            </v-card-title>

            <!--            <v-card-subtitle>-->
            <!--             فروش کل-->
            <!--            </v-card-subtitle>-->

            <v-card-actions>
              <v-btn
                color="green lighten-2"
                text
              >
                {{get_currency(calculate_items(bank_balance,"balance"))}}
                <br>
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="show_bank_balance = !show_bank_balance"
              >
                <v-icon>{{ show_bank_balance ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show_bank_balance">
                <v-divider></v-divider>

                <v-card-text>
                  <v-row v-for="s in bank_balance" >
                    <v-col cols="12">نام حساب: {{s.Title}}</v-col>
                   <v-col cols="12">
                     <table class="table" style="width: 100%">
                       <tr>
                         <td>مانده از قبل</td>
                         <td>بدهکار</td>
                         <td>بستانکار</td>
                       </tr>
                       <tr>
                         <td>{{get_currency(s.balance_before)}}</td>
                         <td>{{get_currency(s.Debtors)}}</td>
                         <td>{{get_currency(s.Creditors)}}</td>
                       </tr>
                     </table>
                   </v-col>
<!--                    <v-col cols="4" >مانده از قبل: {{get_currency(s.balance_before)}}</v-col>-->
<!--                    <v-col cols="4">بدهکار: {{get_currency(s.Debtors)}}</v-col>-->
<!--                    <v-col cols="4">بستانکار: {{get_currency(s.Creditors)}}</v-col>-->
                    <v-col cols="12">مانده: {{get_currency(s.balance)}}</v-col>
                    <v-col cols="12"><hr></v-col>

                  </v-row>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
          <!--          ************************************************-->
          <v-card
            class="mx-auto m-1"
            style="margin: 5px;"

          >

            <v-card-title>
              درخواست های شعب
            </v-card-title>

            <!--            <v-card-subtitle>-->
            <!--             فروش کل-->
            <!--            </v-card-subtitle>-->

            <v-card-actions>
              <v-btn
                color="green lighten-2"
                text
              >
                {{get_currency(calculate_items(branch_requests,"Count"))}}
              </v-btn>

              <v-spacer></v-spacer>

              <v-btn
                icon
                @click="show_branch_requests = !show_branch_requests"
              >
                <v-icon>{{ show_branch_requests ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show_branch_requests">
                <v-divider></v-divider>

                <v-card-text>
                  <div v-for="s in branch_requests">
                    <span>{{ s.Title }}</span>
                    <span style="float: left">{{ get_currency(s.Count) }}</span>
                    <hr>
                  </div>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>
          <!--          ************************************************-->
        </div>
      </div>

    </v-card-text>

  </div>

</template>
<script>
  // import the styles

  import axios from 'axios'
  import Vue from 'vue'

  import {bus} from '../../main'
  import moment from 'moment-jalaali'

  export default {
    props: [
      'passing_data'
    ],
    data() {
      return {
        show_sale_branches: false,
        show_buy_branches: false,
        show_cost_branches: false,
        show_sale_terminal: false,
        show_branch_requests: false,
        show_bank_balance: false,
        branch_sales: [],
        branch_buys: [],
        branch_cost: [],
        terminal_sales: [],
        branch_requests: [],
        bank_balance: [],

        start_date: '',
        end_date: '',
      }
    },
    computed: {},
    components: {},
    watch: {},
    mounted() {
      this.start_date = moment().utc().format('jYYYY/jMM/jDD');
      this.end_date = moment().utc().format('jYYYY/jMM/jDD');

    },

    methods: {

      getReports() {
        // api/AppWebService/GetBranchReq?firstDate=1401/01/23&secondDate=1401/01/30
        //
        //   در خواست ها براساس شعب
        // ------------------------------------------
        //   api/AppWebService/GetReqDay?firstDate=1401/01/23&secondDate=1401/01/30
        //
        //   درخواست های براساس تاریخ مثلا در 7 روز گذشته
        // ------------------------------------------------
        //   api/AppWebService/GetTerminalBalance?firstDate=1401/01/23&secondDate=1401/01/30
        //
        //   فروش هایی ک در پایانه ها تسویه شدن
        // --------------------------------------------------
        //   api/AppWebService/GetBranchSales?firstDate=1401/01/23&secondDate=1401/01/30
        //
        //   فروش شعب
        // --------------------------------------------------
        this.get_branch_sales(151)// forosh
        this.get_branch_sales(102)// buy
        this.get_branch_sales(105)// cost
        this.get_branch_sales()
        this.get_terminal_sales()
        this.get_branch_requests()
        this.get_bank_balance()
      },
      get_branch_sales(type) {
        // this.request_items = [];
        var self = this
// sale 151 buy 102 cost 105
        var url = "https://panel.zoodkomak.com/api/AppWebService/GetBranchSales?docType=" + type + "&firstDate=" + this.start_date + "&secondDate=" + this.end_date
        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post(url, {}, {})
          .then(response => {
            if (type == 151) {
              self.branch_sales = []
              self.branch_sales = response.data
              self.branch_sales.sort(function (a, b) {
                return b.TotalAmount - a.TotalAmount;
              });
            }
            if (type == 102) {
              self.branch_buys = []
              self.branch_buys = response.data
              self.branch_buys.sort(function (a, b) {
                return b.TotalAmount - a.TotalAmount;
              });
            }
            if (type == 105) {
              self.branch_cost = []
              self.branch_cost = response.data
              self.branch_cost.sort(function (a, b) {
                return b.TotalAmount - a.TotalAmount;
              });
            }

          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_terminal_sales() {
        // this.request_items = [];
        var self = this

        var url = "https://panel.zoodkomak.com/api/AppWebService/GetTerminalBalance?firstDate=" + this.start_date + "&secondDate=" + this.end_date
        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post(url, {}, {})
          .then(response => {
            self.terminal_sales = []
            self.terminal_sales = response.data
            self.terminal_sales.sort(function (a, b) {
              return b.TotalAmount - a.TotalAmount;
            });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_branch_requests() {
        // this.request_items = [];
        var self = this

        var url = "https://panel.zoodkomak.com/api/AppWebService/GetBranchReq?firstDate=" + this.start_date + "&secondDate=" + this.end_date
        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post(url, {}, {})
          .then(response => {
            self.branch_requests = []
            self.branch_requests = response.data
            self.branch_requests.sort(function (a, b) {
              return b.Count - a.Count;
            });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_bank_balance() {
        // this.request_items = [];
        var self = this

        var url = "https://panel.zoodkomak.com/api/AppWebService/GetBankBalance?firstDate=" + this.start_date + "&secondDate=" + this.end_date
        console.log('pre request called')
        // this.axios.post('/Register' , send_data,{
        this.axios.post(url, {}, {})
          .then(response => {
            self.bank_balance = []
            var data = JSON.parse(response.data)
            console.log("data is",data)
            data.DetailBalance.forEach(function (val) {
              var balance_before = data.BankBalances.filter(x => x.RecId == val.RecId)[0].Balance;
              var balance = balance_before + (val.Debtors + val.Creditors)
              self.bank_balance.push({
                Title: val.Title,
                balance_before: balance_before,
                Creditors: val.Creditors,
                Debtors: val.Debtors,
                RecId: val.RecId,
                balance: balance
              })
            })
            // self.bank_balance.sort(function(a, b) {
            //   return b.Count - a.Count;
            // });
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
